import { gql } from '@apollo/client';

import { teachingAndLearningSequenceFragment } from 'approot/activity-builder/components/teaching-notes/teaching-notes.graphql';

export const GET_ASSESSMENT_TEACHING_LEARNING_SEQUENCE = gql`
  query GetAssessmentTeachingAndLearningSequence(
    $input: GetTeachingAndLearningSequenceInput!
  ) {
    getAssessmentTeachingAndLearningSequence(input: $input) {
      ...TeachingLearningSequenceFragment
    }
  }
  ${teachingAndLearningSequenceFragment}
`;
